import React, { useLayoutEffect, useRef } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Pricing } from './pages/Pricing';
import { AdditionalCosts } from './pages/AdditionalCosts';
import { Contact } from './pages/Contact';
import { Industries } from './pages/Industries';
import { Crm } from './pages/Crm';
import { Websites } from './pages/Websites';
import { useHashRoute, type Route } from './hooks/useHashRoute';
import { trackPageView } from './utils/tracking';
const pageTitles: Record<Route, string> = {
  home: 'Ad ROI Marketing | Marketing & Conversions',
  pricing: 'Pricing & Plans | Ad ROI Marketing',
  additionalCosts: 'Additional Costs & Usage Rates | Ad ROI Marketing',
  contact: 'Contact Us | Ad ROI Marketing',
  industries: 'Industries We Serve | Ad ROI Marketing',
  crm: '1Dash.Pro CRM | Ad ROI Marketing',
  websites: 'Living Websites: Websites That Run Themselves | Ad ROI Marketing'
};
export function App() {
  const route = useHashRoute();
  const firstView = useRef(true);
  useLayoutEffect(() => {
    document.title = pageTitles[route];
    // Initial load is tracked here; later hash changes are tracked by the global listener.
    if (firstView.current) {
      firstView.current = false;
      trackPageView();
    }
  }, [route]);
  return <div className="min-h-screen w-full bg-white font-sans text-gray-900 selection:bg-red-200 selection:text-red-900" data-id="element-0" data-mp="2zlv8x0aavbxp">
      <AnnouncementBar data-id="element-1" data-mp="33ngfy505kvzz" />
      <Navbar route={route} data-id="element-2" data-mp="33orik1hv3xpi" />
      <main data-id="element-3" data-mp="38m1elzzrb7mb">
        {route === 'pricing' && <Pricing data-id="element-4" data-mp="38l04pyuh8r66" />}
        {route === 'additionalCosts' && <AdditionalCosts data-id="element-5" data-mp="3dkuw03i5zirr" />}
        {route === 'contact' && <Contact data-id="element-6" data-mp="3dlnwwnufze1z" />}
        {route === 'industries' && <Industries data-id="element-7" data-mp="nvj3xh1mugq9" />}
        {route === 'crm' && <Crm data-id="element-8" data-mp="nur762waucye" />}
        {route === 'websites' && <Websites data-id="element-9" data-mp="nxww9i4xheu4" />}
        {route === 'home' && <Home data-id="element-10" data-mp="studdqo0mp7y" />}
      </main>
      <Footer data-id="element-11" data-mp="st2i6gybyti7" />
    </div>;
}